<template>
  <div name="pupiladd" class="-mx-3 mt-2">
    <section v-if="errored" class="w-full text-center mt-2">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the pupil details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <div class="overflow-y-auto pt-8" v-if="componentLoaded">

      <h4 v-if="hasFeeling" class="px-4 -mt-4 mb-12 font-bold text-gray-600">Feeling recorded on: <span class="text-black">{{ postedOn }}</span> </h4>

      <section class="mx-auto w-11/12 text-center mb-4">
        <div class="flex justify-center">
          <button
            v-for="object in questionAnwerList.slice(0, 2)"
            :key="object.id"
            @click="setFeeling(object)"
            class="feeling-box hover:opacity-50 mx-5 excited-bg"
            :class="setClass(object)"
          >
            <div class="transform -rotate-45 flex flex-col">
              <i
                class="fas fa-check-circle text-3xl absolute -mt-4 bg-white rounded-full"
                v-if="isOn(object)"
              ></i>
              <img :src="contentImage(object)" class="w-16 h-16 mx-auto" />
              <div>{{ object.answer.content }}</div>
            </div>
          </button>
        </div>

        <div class="flex justify-center">
          <button
            v-for="object in questionAnwerList.slice(2, 5)"
            :key="object.id"
            @click="setFeeling(object)"
            class="feeling-box hover:opacity-50 mx-5 happy-bg"
            :class="setClass(object)"
          >
            <div class="transform -rotate-45 flex flex-col">
              <i
                class="fas fa-check-circle text-3xl absolute -mt-4 bg-white rounded-full"
                v-if="isOn(object)"
              ></i>
              <img :src="contentImage(object)" class="w-16 h-16 mx-auto" />
              <div>{{ object.answer.content }}</div>
            </div>
          </button>
        </div>

        <div class="flex justify-center">
          <button
            v-for="object in questionAnwerList.slice(5, 7)"
            :key="object.id"
            @click="setFeeling(object)"
            class="feeling-box hover:opacity-50 mx-5"
            :class="setClass(object)"
          >
            <div class="transform -rotate-45 flex flex-col">
              <i
                class="fas fa-check-circle text-3xl absolute -mt-4 bg-white rounded-full"
                v-if="isOn(object)"
              ></i>
              <img :src="contentImage(object)" class="w-16 h-16 mx-auto" />
              <div>{{ object.answer.content }}</div>
            </div>
          </button>
        </div>
      </section>

      <section class="w-11/12 px-3 py-8 mb-12">
        <textarea
          class="bg-gray-200 rounded-xl border border-gray-100 leading-normal resize-none w-full h-20 py-2 px-3 font-medium placeholder-gray-700 focus:outline-none focus:bg-gray-100"
          name="body"
          placeholder="Add a comment"
          v-model="comment"
          required
        ></textarea>

        <div class="w-full mt-4">
          <button
            @click="submitForm()"
            type="button"
            :disabled="isDisabled"
            class="h-10 publish-button hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4"
          >
            Save your information
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { WellbeingService } from "@/services/wellbeing.service";
import { calendarYearList } from "@/assets/js/utils";

export default {
  name: "feeling",
  props: {
    pupil: { type: Object, required: true },
    measurement: { type: Object, required: true },
    feeling: { type: Object, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.loading === false;
    },
    isDisabled() {
      return this.selectedAnswer === undefined;
    },
    // ...mapGetters({ currentUser: 'currentUser' }),
    questionAnwerList() {
      return _.orderBy(
        this.questions[0].answers,
        "display_order"
      );
    },
    postedOn() {
      return  moment(this.feeling.modified_date).format('Do MMMM YYYY');
    },
    hasFeeling() {
      return this.feeling != undefined
    }
  },
  data() {
    return {
      school: this.$store.getters.school,
      errored: false,
      loading: true,
      isComplete: false,
      surveys: [],
      comment: "",
      selectedAnswer: undefined,
      selectedSurvey: undefined,
      questions: []
    };
  },
  created() {},
  mounted() {
    this.getSurveys();
    if (this.feeling != undefined) {
      this.comment = this.feeling.notes
      this.selectedAnswer = this.feeling
    }

  },
  methods: {
    getSurveys() {
      WellbeingService.getWorkoutAreaSurveys()
        .then((response) => ( this.setSurveyData(response.data.data)))
        .catch((err) => {
          console.log("Surveys " + err);
          this.errored = true;
        })
     
    },
    setSurveyData(data) {
      this.surveys = data
      this.selectedSurvey = data[0]
      this.getSurveyQuestions()
    },
    getSurveyQuestions() {
      WellbeingService.getSurveyQuestions(this.selectedSurvey)
        .then((response) => (this.questions = response.data.data))
        .catch((err) => {
          console.log("Surveys " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    completion() {
      this.isComplete = true;
      this.$emit("feeling-added");
      window.scrollTo(0, 0);
    },
    failure(error) {
      this.isComplete = false;
      this.errored = true;
      console.log("Pupil update error " + error);
    },
    contentImage(object) {
      return require("@/assets/images/selfassess/icons/" +
        object.answer.key_value +
        ".png");
    },
    isOn(object) {
      if (this.selectedAnswer === undefined) { return false }
      return this.selectedAnswer.survey_answer.identifier === object.identifier;
    },
    setClass(object) {
      return object.answer.key_value + "-bg";
    },
    setFeeling(object) {
      this.selectedAnswer = {survey_answer: object};
    },
    submitForm() {
      this.isSaving = true;
      console.log(this.feeling === undefined)
      
      if (this.feeling === undefined) {
        let calendarYear = calendarYearList().find((y) => y.current === true);
        var payload = {
          content: this.selectedAnswer.survey_answer.answer.content,
          wb_survey_answer_identifier: this.selectedAnswer.survey_answer.identifier,
          calendar_schoolyear: calendarYear.value,
          notes: this.comment,
          register_identifier: this.pupil.identifier,
          measurement_identifier: this.measurement.identifier,
        };

        WellbeingService.addReply(payload)
          .then((response) => this.completion())
          .catch((err) => {
            this.failure(err);
          })
          .finally(() => (this.isSaving = false));
      } else {
        
        this.feeling.content = this.selectedAnswer.survey_answer.answer.content
        this.feeling.wb_survey_answer_identifier = this.selectedAnswer.survey_answer.identifier
        this.feeling.notes = this.comment

        WellbeingService.updateReply(this.feeling)
          .then((response) => this.completion())
          .catch((err) => {
            this.failure(err);
          })
          .finally(() => (this.isSaving = false));
      }
    },
  },
  components: {},
};
</script>

<style scoped>


.happy-bg {
  background-color: rgb(208, 154, 226, 0.2);
  color: #d09ae2;
}

.happy-bg.on {
  border-color: #d09ae2;
  border-width: 1px;
}

.excited-bg {
  background-color: rgb(219, 154, 94, 0.2);
  color: rgb(219, 154, 94, 0.9);
}

.excited-bg.on {
  border-color: #db9a5e;
  border-width: 1px;
}

.loved-bg {
  background-color: rgb(224, 119, 160, 0.2);
  color: rgb(224, 119, 160, 0.5);
}

.loved-bg.on {
  border-color: #e077a0;
  border-width: 1px;
}

.okay-bg {
  background-color: rgb(175, 175, 175, 0.2);
  color: rgb(175, 175, 175, 0.9);
}

.okay-bg.on {
  border-color: #afafaf;
  border-width: 1px;
}

.bored-bg {
  background-color: rgb(147, 154, 193, 0.2);
  color: rgb(147, 154, 193, 0.5);
}

.bored-bg.on {
  border-color: #939ac1;
  border-width: 1px;
}

.sad-bg {
  background-color: rgb(105, 139, 188, 0.2);
  color: rgb(105, 139, 188, 0.5);
}

.sad-bg.on {
  border-color: #698bbc;
  border-width: 1px;
}

.angry-bg {
  background-color: rgb(196, 101, 101, 0.2);
  color: rgb(196, 101, 101, 0.9);
}

.angry-bg.on {
  border-color: #c46565;
  border-width: 1px;
}

/* 
Bored - #

Sad - #

Angry - #

Loved - #

Excited - #

Crying - #749aa3 */
</style>